import React, { useEffect, useRef } from "react";
import {
  Route, Routes, useLocation, useNavigate,
} from "react-router-dom";
import Step from "widgets/Onboarding/components/Step/Step";
import PropTypes from "prop-types";

const RouteGenerator = ({ routes, handleSubmit, navigateToRoute }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialRender = useRef(true);

  useEffect(() => {
    if (location.pathname !== "/onboarding/beneficiary" && initialRender.current) {
      navigate(`/beneficiary${window.location.search}`);
    }
    initialRender.current = false;
  }, [location.pathname, navigate]);

  useEffect(() => {
    // navigate if route change triggered by non-browser buttons
    if (navigateToRoute && !location.pathname.includes(navigateToRoute)) {
      navigate(navigateToRoute + window.location.search);
    }
  }, [navigateToRoute, navigate, location.pathname]);

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.step.path}
          path={route.step.path}
          element={(
            <Step
              step={route.step}
              form={route.form}
              bodyCopy={route.bodyCopy}
              onSubmit={handleSubmit}
            />
          )}
        />
      ))}
    </Routes>
  );
};

RouteGenerator.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      step: PropTypes.shape({
        path: PropTypes.string.isRequired,
      }).isRequired,
      form: PropTypes.array.isRequired,
      bodyCopy: PropTypes.object,
    }).isRequired,
  ).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  navigateToRoute: PropTypes.string,
};

export default RouteGenerator;
